import template from "./quote-section-name-form.html";

const QuoteSectionNameFormComponent = {
  bindings: {
    sectionName: "=",
    name: "<",
    onSave: "&",
  },
  template: template,
  controller: class QuoteSectionNameFormController {
    $onInit() {
      if (this.sectionName) this.name = this.sectionName;
    }

    save() {
      if (this.form.$valid) this.onSave({ name: this.name });
    }
  },
};

export default QuoteSectionNameFormComponent;
